(function () {
    'use strict';
    angular
        .module('ib-basket-section')
        .factory('ibBasketSectionTransformer', ibBasketSectionTransformer);

    ibBasketSectionTransformer.$inject = ['localStorageService', 'CurrencyService', 'NewMainHeaderConstants'];
    function ibBasketSectionTransformer (localStorageService, CurrencyService, NewMainHeaderConstants) {

        return {
            setInfoAncillarie: setInfoAncillarie,
            setPriorityInfoAncillarie: setPriorityInfoAncillarie
        };

        function setInfoAncillarie (flexInfo) {
            const flexData = {
                info: null,
                hasFlexibilization: false
            };
            const currency = localStorageService.get('currency');

            if (flexInfo) {
                flexData.info = NewMainHeaderConstants.FLEXIBILIZATION_CONFIG;
                flexData.info.currency = currency;
                flexData.info.amount.price = flexInfo.total;
                flexData.info.amount.priceFormatted = CurrencyService.formatPrice(currency, flexInfo.total, true);
                flexData.info.items = [
                    {
                        concepts: [
                            {
                                quantity: 1,
                                description: flexInfo.description,
                                price: flexInfo.total,
                                priceFormatted: CurrencyService.formatPrice(currency, flexInfo.total, true)
                            }
                        ]
                    }
                ];

                flexData.hasFlexibilization = true;
            }

            return flexData;
        }

        function setPriorityInfoAncillarie (priorityInfo) {
            const priorityData = {
                info: null,
                hasPriorityBoarding: false
            };
            const currency = localStorageService.get('currency');

            if (priorityInfo) {
                priorityData.info = NewMainHeaderConstants.PRIORITY_BOARDING_CONFIG;
                priorityData.info.currency = currency;
                priorityData.info.trips = totalPricePriorityBoarding(priorityInfo);
                priorityData.info.amount = priorityData.info.trips.totalPrice;
                priorityData.info.priceFormatted = CurrencyService.formatPrice(currency, priorityData.info.trips.totalPrice, true);
                if (priorityData.info.amount == 0) {
                    priorityData.hasPriorityBoarding = false;
                } else {
                    priorityData.hasPriorityBoarding = true;
                }
            }

            function totalPricePriorityBoarding (priorityInfo) {
                let i, j, total = 0, trips = [], position;
                for (i = 0; i < priorityInfo.length; i++) {
                    for (j = 0; j < priorityInfo[i].trips.length; j++) {
                        if (priorityInfo[i].trips[j].checkedTrip) {
                            total += priorityInfo[i].trips[j].amount;
                            position = searchSegment(priorityInfo[i].trips[j].id, trips);
                            if (position == null) {
                                trips.push({
                                    id: priorityInfo[i].trips[j].id,
                                    arrival: priorityInfo[i].trips[j].arrival,
                                    departure: priorityInfo[i].trips[j].departure,
                                    amount: priorityInfo[i].trips[j].amount,
                                    priceFormatted: CurrencyService.formatPrice(currency, priorityInfo[i].trips[j].amount, true),
                                    quantity: 1
                                });
                            } else {
                                position.amount += priorityInfo[i].trips[j].amount;
                                position.priceFormatted = CurrencyService.formatPrice(currency, position.amount, true);
                                position.quantity++;
                            }
                        }
                    }
                }
                trips.totalPrice = total;
                return trips;
            }

            function searchSegment (segmentsId, segments) {
                let i;
                for (i = 0; i < segments.length; i++) {
                    if (segments[i].id === segmentsId) {
                        return segments[i];
                    }
                }
            }

            return priorityData;
        }

    }
})();
